import { GOODS_ACTIVITY_TYPE_V } from '@src/constants';
import { deepClone } from '@utils/index';
import BasePackageHeaderBg from '@assets/img/storeFront/base.png'

class MultiActivity {
    private data: any = {}

    constructor(data) {
        this.data = deepClone(data) || {};
        this.initFilterActivityPlan()
    }

    /**
     * 是否有限时秒杀活动
     * @returns {any}
     */
    public getSpikeActivity = (): any => {
        return this.data.activityPlan.find(item => item.activityType === 'DISCOUNT' && item.discountType === '2')
    };

    /**
     * 重新生成套餐有效期
     */
    public formatPackageValidDate = () => {
        const { timeUnit, timeLength, goodsNumber } = this.data
        const obj = {
            goodsTime: 0,
            unit: ''
        }
        if (timeUnit === '0') {
            obj.goodsTime = goodsNumber * Number(timeLength)
            obj.unit = '0'
        }
        if (timeUnit === '1') {
            obj.goodsTime = Number(timeLength) === 30 && goodsNumber > 1 ? goodsNumber : goodsNumber * Number(timeLength)
            obj.unit = Number(timeLength) === 30 && goodsNumber > 1 ? '0' : '1'
        }
        return obj
    }
    /**
     * 判断是否有有效的活动
     */
    public hasEffectiveActivity = (): boolean => {
        return this.data.activityPlan.length > 0
    }
    /**
     * 是否可以使用优惠券
     */
    public canUseCoupon = (): boolean => {
        const { mutexConigDtos = [], activityPlan } = this.data
        // 无活动或者没有互斥规则或者互斥规则中没有使用优惠券限制
        return activityPlan.length === 0 || mutexConigDtos.length === 0 || mutexConigDtos.every(item => !item.mutexActids.includes('-1'))
    }

    /**
     * 获取不在互斥规则中的活动列表
     */
    public getActivityListOutMutex = () => {
        // 将互斥活动的二维数组转成一维数组
        if (this.formatActivityByMutexConfig().length > 0) {
            const mutexActivityList = this.formatActivityByMutexConfig().reduce((prev, current) => {
                return [...prev, ...current]
            }, [])
            return this.data.activityPlan.filter(item => {
                return !mutexActivityList.find(item1 => item1.activityId === item.activityId)
            })
        }
        return this.data.activityPlan
    }

    /**
     * 判断是否存在售罄的显示打折活动
     */
    public isSaleOut = dto => {
        return dto.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE && dto.stock != null && dto.stock <= 0
    }

    /**
     * 判断是否存在个人限购达上限的情况
     * @param dto
     */
    public isPurchaseLimit = dto => {
        return dto.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE && dto.totalParticipateNum && dto.totalParticipateNum - dto.participateNum <= 0
    }

    /**
     * 根据每一条互斥规则中的mutexActids找到对应的活动列表
     */
    public getActivityByMutex = (mutexArr, activityPlan) => {
        const arr = []
        mutexArr.forEach(i => {
            if (i === '-1') {
                arr.push('-1')
            } else {
                if (!!activityPlan.find(j => j.activityId === i)) {
                    arr.push(activityPlan.find(j => j.activityId === i))
                }
            }
        })
        return arr
    }

    /**
     * 根据互斥规则重新生成活动列表
     */
    public formatActivityByMutexConfig = () => {
        const activityList = []
        const { activityPlan, mutexConigDtos = [] } = this.data

        // 有活动且有互斥规则
        if (activityPlan.length > 0 && mutexConigDtos.length > 0) {
            mutexConigDtos.forEach(item => {
                activityList.push(this.getActivityByMutex(item.mutexActids.split(','), activityPlan))
            })
        }
        return activityList
    }

    /**
     * 活动角标展示文字及颜色
     * @returns {object}
     */
    public getActivitySubTag = () => {
        return {
            planLabel: this.data.activityPlan[0].cornerMark || '',
            labelColor: this.data.activityPlan[0].labelColor || '1'
        }
    }

    /**
     * 获取活动标签列表
     * @returns {string}
     */
    public getPlanLabelList = (): string[] => {
        const planLabelList = []
        let arr = []
        if (this.data.activityPlan.length > 3) {
            const [a, b, c] = this.data.activityPlan
            arr = [a, b, c]
        } else {
            arr = this.data.activityPlan
        }
        arr.forEach(item => {
            planLabelList.push(item.planLabel)
        })
        return planLabelList
    }

    /**
     * 是否展示套餐原价
     * @returns {boolean}
     */
    public showOldPrice = (): boolean => {
        let flag = false
        if (this.hasEffectiveActivity()) {
            const bigSaleActivityList = this.data.activityPlan.filter(item => item.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
            if (bigSaleActivityList.length > 0) {
                flag = true
            }
        }
        return flag
    }
    /**
     * 获取营销卖点
     * @returns {string}
     */
    public getSellingPointer = (): string => {
        let sellingPoint = ''
        if (this.hasEffectiveActivity()) {
            const dto = this.data.activityPlan.find(item => item.sellingPoint != '' || item.sellingPoint != null)
            sellingPoint = dto ? dto.sellingPoint : ''
        }
        return sellingPoint
    };
    /**
     * 获取套餐卡片活动头图，取优先级最高的一个
     * @returns {string}
     */
    public getActivityHeaderImg = (): string => {
        return this.data.pictureUrl || BasePackageHeaderBg
    };
    /**
     * 获取套餐原价，有活动时用到
     * @returns {number}
     */
    public getOldPrice = (): number => {
        return Number(this.data.totalPrice)
    };

    /**
     * 获取套餐展示价格
     * @returns {number}
     */
    public getPriceForShow = (): number => {
        let price = 0
        if (this.hasEffectiveActivity()) {
            const bigSaleActivityList = this.data.activityPlan.find(item => item.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
            price = !!bigSaleActivityList ? this.data.minPrice : this.data.totalPrice
        } else {
            price = this.data.totalPrice
        }
        return Number(price)
    }

    /**
     * 对活动列表进行初始化过滤，过滤掉售罄或者限购的活动
     */
    private initFilterActivityPlan = () => {
        if (this.data && this.data.activity && this.data.activityPlan) {
            this.data.activityPlan.forEach((item, index) => {
                // 如果是限时打折活动并且售罄或者限购，删掉当前活动
                if ((item.activityType === 'DISCOUNT' && item.discountType === '1' && (this.isPurchaseLimit(item) || this.isSaleOut(item))) || (item.activityType === 'FREE' && item.remainingNum === 0)) {
                    this.data.activityPlan.splice(index, 1)
                }
            })
        } else {
            this.data.activityPlan = []
        }
    };
}

export default MultiActivity
